import front from "../../../assets/demoImages/front.png";
import upperJaw from "../../../assets/demoImages/upper-reversed.png";
import lowerJaw from "../../../assets/demoImages/lower.png";
import left from "../../../assets/demoImages/left.png";
import right from "../../../assets/demoImages/right.png";

export const steps = [
    {
        title: "Front teeth",
        label: "ရှေ့သွား",
        image: front,
        tips: ["Align the front teeth inside the template"]
    },
    {
        title: "Left side",
        label: "ဘယ်ဘက်",
        image: left,
        tips: ["Pull the corner of your mouth as back as possible"],
    },
    {
        title: "Right side",
        label: "ညာဘက်",
        image: right,
        tips: ["Pull the corner of your mouth as back as possible"]
    },
    {
        title: "Lower jaw",
        label: "အောက်ဘက်",
        image: lowerJaw,
        tips: ["Open your mouth tilt your head downwards"]
    },
    {
        title: "Upper jaw",
        label: "အပေါ်ဘက်",
        image: upperJaw,
        tips: ["Open your mouth tilt your head backwards"]
    },

];

